import { NgModule } from '@angular/core';
import { LoaderComponent } from './loader.component';

/**
 * @deprecated Import the LoaderComponent directly
 */
@NgModule({
  imports: [LoaderComponent],
  exports: [LoaderComponent]
})
export class LoaderModule {}
